module.exports = __webpack_public_path__ + "static/img/Music.d470ef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/browse/Music.jpg
// module id = 1952
// module chunks = 0